import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  brandName = 'Nick Smith Consulting';
  pageClass: string;

  constructor(private router: Router) {
    router.events.subscribe((route:any) => {
      const page = route.url.substr(1).replace('/', '-');
      if (!page.length) {
        this.pageClass = 'main-home-page';
      } else {
        this.pageClass = 'main-' + page + '-page';
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/jonshilton/Projects/nick-smith-app/src/app/app.component.ts